import i18n from "i18next";
import { initReactI18next } from "react-i18next";
const resources = require("./resources.json");

/**
 * 사용법:
 * boot.tsx 등에서 현재 파일을 import.
 * ex) `import './i18n';`
 * 라고 선언하면 된다.
 */

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "ko-KR",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;